export enum RootRoutePathNames {
  ROOT = '/',
}
